<template>
  <v-layout>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="base"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:top>
          <v-toolbar elevation="0">
            <v-toolbar-title>Base de datos proveedores</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined icon color="green" v-bind="attrs" v-on="on"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Actualizar tabla</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-col cols="4">
              <v-text-field
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Busqueda"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="ml-5" @click="VerNuevo()"
              >Nuevo</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="verDetalles(item)"
                v-bind="attrs"
                v-on="on"
              >
                tab
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-overlay v-model="overlay" z-index="1">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackMensajeFechas" color="cyan darken-2" top
        >Debe de seleccionar ambas fechas.</v-snackbar
      >
      <v-snackbar v-model="snackError" color="yellow darken-3" top
        >Hubo un error, verificar conexión o recargar la pagina.</v-snackbar
      >

      <v-row v-if="verNuevo == 1 || verDet == 1" no-gutters>
        <v-col cols="12" class="pa-0">
          <v-toolbar elevation="1">
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="verNuevo == 1" @click="CerrarNuevo()"
              >Cerrar</v-btn
            >
            <v-btn
              color="primary"
              class="ml-5"
              v-if="verDet == 0"
              @click="guardar()"
              >Guardar</v-btn
            >
            <v-btn
              color="primary"
              class="ml-5"
              v-if="verDet == 1"
              @click="actualizar()"
              >Actualizar</v-btn
            >
          </v-toolbar>
        </v-col>
        <v-row class="pa-3">
          <v-col cols="4">
            <v-text-field v-model="dui" label="DUI" counter="15"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="nit" label="NIT" counter="25"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="registroFiscal"
              label="REGISTRO FISCAL"
              counter="50"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="proveedor"
              label="PROVEEDOR"
              counter="50"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="nombrePropietario"
              label="NOMBRE DE PROPIETARIO"
              counter="50"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="pais"
              label="PAIS"
              counter="50"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="telefono"
              label="TELEFONO"
              counter="50"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="correo"
              label="CORREO ELECTRONICO"
              counter="30"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="banco"
              label="BANCO"
              counter="30"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="cuenta"
              label="CUENTA #"
              counter="30"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="tipoServicio"
              label="TIPO DE SERVICIO"
              counter="30"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="expediente"
              label="EXPEDIENTE"
              counter="30"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      base: [],
      search: "",
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "DUI",
          value: "dui",
          align: "left",
        },
        {
          text: "NIT",
          value: "nit",
          align: "center",
        },
        {
          text: "REGISTRO FISCAL",
          value: "registroFiscal",
          align: "center",
        },
        {
          text: "PROVEEDOR",
          value: "proveedor",
          align: "center",
        },
        {
          text: "NOMBRE PROPIETARIO",
          value: "nombrePropietario",
          align: "center",
        },
        {
          text: "PAIS",
          value: "pais",
          align: "center",
        },
        {
          text: "TELEFONO",
          value: "telefono",
          align: "center",
        },
        {
          text: "BANCO",
          value: "banco",
          align: "center",
        },
      ],
      verNuevo: 0,
      verDet: 0,
      snackMensajeFechas: false,
      snackError: false,
      overlay: false,
      fechaInicio: "",
      fechaFin: "",
      idBaseProveedorBaucher: "",
      dui: "",
      nit: "",
      registroFiscal: "",
      proveedor: "",
      nombrePropietario: "",
      pais: "",
      telefono: "",
      correo: "",
      banco: "",
      cuenta: "",
      tipoServicio: "",
      expediente: "",
    };
  },
  created() {
    this.listar();
  },
  methods: {
    VerNuevo() {
      this.verNuevo = 1;
    },
    CerrarNuevo() {
      this.verNuevo = 0;
      this.verDet = 0;
      this.limpiar();
    },
    verDetalles(item) {
      this.verNuevo = 1;
      this.verDet = 1;
      this.idBaseProveedorBaucher = item.idBaseProveedorBaucher;
      this.dui = item.dui;
      this.nit = item.nit;
      this.registroFiscal = item.registroFiscal;
      this.proveedor = item.proveedor;
      this.nombrePropietario = item.nombrePropietario;
      this.pais = item.pais;
      this.telefono = item.telefono;
      this.correo = item.correo;
      this.banco = item.banco;
      this.cuenta = item.cuenta;
      this.tipoServicio = item.tipoServicio;
      this.expediente = item.expediente;
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/BaseProveedoresBauchers/Listar", configuracion)
        .then(function (response) {
          me.base = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "api/BaseProveedoresBauchers/Crear",
          {
            dui: me.dui,
            nit: me.nit,
            registroFiscal: me.registroFiscal,
            proveedor: me.proveedor,
            nombrePropietario: me.nombrePropietario,
            pais: me.pais,
            telefono: me.telefono,
            correo: me.correo,
            banco: me.banco,
            cuenta: me.cuenta,
            tipoServicio: me.tipoServicio,
            expediente: me.expediente,
          },
          configuracion
        )
        .then(function (response) {
          me.CerrarNuevo();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    actualizar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/BaseProveedoresBauchers/Actualizar",
          {
            idBaseProveedorBaucher: me.idBaseProveedorBaucher,
            dui: me.dui,
            nit: me.nit,
            registroFiscal: me.registroFiscal,
            proveedor: me.proveedor,
            nombrePropietario: me.nombrePropietario,
            pais: me.pais,
            telefono: me.telefono,
            correo: me.correo,
            banco: me.banco,
            cuenta: me.cuenta,
            tipoServicio: me.tipoServicio,
            expediente: me.expediente,
          },
          configuracion
        )
        .then(function (response) {
          me.CerrarNuevo();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      this.idBaseProveedorBaucher = "";
      this.dui = "";
      this.nit = "";
      this.registroFiscal = "";
      this.proveedor = "";
      this.nombrePropietario = "";
      this.pais = "";
      this.telefono = "";
      this.correo = "";
      this.banco = "";
      this.cuenta = "";
      this.tipoServicio = "";
      this.expediente = "";
    },
  },
};
</script>